import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'

type InvitationRequest = Omit<paths['/api/carts/multi-carts/{multiCartId}/users/invite']['post']['requestBody']['content']['application/json'], 'brand'>
type InvitationResponse = paths['/api/carts/multi-carts/{multiCartId}/users/invite']['post']['responses']['201']['content']['application/json']

export type MultiCartInvitationUsers = paths['/api/carts/multi-carts/{multiCartId}/users/invite']['post']['requestBody']['content']['application/json']['users']

export function inviteUsersToMultiCart(cartId: string, users: MultiCartInvitationUsers) {
  const payload = { users }
  return request.post<InvitationResponse, InvitationRequest>(`/api/carts/multi-carts/${cartId}/users/invite`, payload, { credentials: 'include' })
}
